import TagManager from 'react-gtm-module';
import settings from '../config/settings';
import { uiVersion, getAppVersion, getPlatform } from '../utils/mobile';

class GtmService {
  constructor() {
    this.dataLayerDefault = {
      event: 'gemsTracking',
      category: 'General',
      action: 'General',
      label: 'General',
      version: `${uiVersion} ${getAppVersion()} ${getPlatform()}`,
      affiliate: undefined,
      isStaffUser: undefined,
      app: 'GEMS Access',
    };

    const tagManagerArgs = {
      gtmId: settings.gtm_id,
      dataLayerName: 'PageDataLayer',
    };

    TagManager.initialize(tagManagerArgs);
  }

  setupDefaultDataLayer(data) {
    this.dataLayerDefault = { ...this.dataLayerDefault, ...data };
  }

  dataLayer(data) {
    const gtmId = window.settings.gtm_id;

    // Cleanup data layer for avoiding unused fields inheritance
    if (window.google_tag_manager && window.google_tag_manager[gtmId]) {
      window.google_tag_manager[gtmId].dataLayer.reset();

      const dataLayer = { ...this.dataLayerDefault, ...data };

      const tagManagerArgs = {
        dataLayer,
        dataLayerName: 'PageDataLayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  }
}

export default new GtmService();



// WEBPACK FOOTER //
// ./src/services/GtmService.js